import { useTranslation } from 'react-i18next'
import { useDeletePoiMutation } from '@/entities/poi'
import { DeleteButtonWithConfirm } from '@/shared/ui/delete-button-with-confirm'

interface PoiDeleteButtonProps {
  poiId: string
  onDeleted?: () => void
}

export function PoiDeleteButton({ poiId, onDeleted }: PoiDeleteButtonProps) {
  const { t } = useTranslation()
  const mutation = useDeletePoiMutation()

  return (
    <DeleteButtonWithConfirm
      onDelete={async () => {
        await mutation.mutateAsync(poiId)
      }}
      isPending={mutation.isPending}
      confirmTitle={t('poi.deleteConfirm')}
      successMessage={t('poi.deleteSuccess')}
      {...(onDeleted ? { onDeleted } : {})}
    />
  )
}
